import React from "react";

import {
  Alert,
  CardStackSection,
  Heading,
  Stack,
  Text,
  Card,
  MarkdownLite,
} from "@origin-digital/ods-core";

import {
  ProfileFieldMapTypes,
  isBroadbandOnlyCustomer,
} from "src/crm/profileFieldMapContextHelpers";
import {
  FieldUpdateHook,
  ContactPreferenceRefetchFieldFunction,
  FieldUpdateHookUnsupported,
  FIELD_UPDATE_HOOK_UNSUPPORTED,
} from "../../crm/profileFieldMap";
import content from "./content.json";
import { ContactOption, ContactPreferenceProp } from "./ContactOption";
import { MarketPrefsCard } from "./MarketPreferences";
import { EmailNotifications } from "./EmailNotifications";

export interface IProps {
  contacts: ContactPreferenceProp[];
  useUpdate:
    | FieldUpdateHook<ContactPreferenceProp>
    | FieldUpdateHookUnsupported;
  refetch: ContactPreferenceRefetchFieldFunction;
  type: ProfileFieldMapTypes;
  hasActiveBroadband: boolean;
}

export const UpdateContactPrefsScreen: React.FC<IProps> = ({
  contacts,
  useUpdate,
  refetch,
  type,
  hasActiveBroadband = false,
}) => {
  return (
    <CardStackSection data-id="contact-preferences">
      {/* This prevents rendering the card for broadband only user */}
      {isBroadbandOnlyCustomer(type) ? (
        <></>
      ) : (
        <Card data-id="contact-preferences-card">
          <Stack space={["large", "xlarge"]}>
            <Heading variant="h3">{content.heading}</Heading>
            <Stack space={["medium", "large"]}>
              <Text data-id="info-message">{content.info}</Text>
              <Stack
                data-id="contact-options"
                space={["large", "xlarge"]}
                dividers
              >
                {contacts.length > 0 &&
                  contacts.map((contact, idx) => {
                    if (useUpdate === FIELD_UPDATE_HOOK_UNSUPPORTED) {
                      return null; // Skip rendering if useUpdate is unsupported
                    }
                    return (
                      <ContactOption
                        key={contact.id || idx}
                        data-id="account-option"
                        contact={contact}
                        useUpdate={useUpdate}
                        refetch={refetch}
                        type={type}
                      />
                    );
                  })}
                {contacts.length === 0 && (
                  <Alert data-id="no-account-alert">{content.noAccounts}</Alert>
                )}
              </Stack>
            </Stack>
            <Stack space="xsmall" data-id="contact-disclaimer">
              {content.disclaimer.map((line, key) => (
                <Text key={key} variant="body-small">
                  <MarkdownLite>{line}</MarkdownLite>
                </Text>
              ))}
            </Stack>
          </Stack>
        </Card>
      )}
      {hasActiveBroadband ? (
        <EmailNotifications key="email-notifications" />
      ) : (
        <></>
      )}
      <MarketPrefsCard />
    </CardStackSection>
  );
};
